import { render, staticRenderFns } from "./ModalAddCourse.vue?vue&type=template&id=3e5bb4d2&scoped=true"
import script from "./ModalAddCourse.vue?vue&type=script&lang=js"
export * from "./ModalAddCourse.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCourse.vue?vue&type=style&index=0&id=3e5bb4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5bb4d2",
  null
  
)

export default component.exports